module.exports = __webpack_public_path__ + "static/media/icon_product_foods.da71d4b8.svg";